import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  zh: {
    translation: {
      brand: {
        name: "海神音乐",
        nameEn: "Poseidon Music",
      },
      nav: {
        hero: "首页",
        about: "关于",
        contact: "联系",
      },
      hero: {
        eyebrow: "中文音乐厂牌 · CHINESE MUSIC LABEL",
        tagline: "潮起潮落，乐韵永恒",
        taglineEn: "Tides Rise and Fall · Music Echoes Eternal",
        scroll: "向下滚动",
      },
      about: {
        eyebrow: "关于我们 · ABOUT",
        title: "以潮汐之势，推动中文音乐抵达远海。",
        body1: "Poseidon Music 是一个专注于中文音乐发行与全球合作的独立厂牌。我们信奉作品本身的力量——如同海神的三叉戟，精准、锋利、持久。",
        body2: "从创作、制作、发行到全球分发，我们与艺术家并肩航行，让每一次浪起，都是一次回响。",
        statReleases: "年内发行",
        statReleasesValue: "36+",
        statArtists: "签约艺人",
        statArtistsValue: "12",
        statMarkets: "覆盖市场",
        statMarketsValue: "亚洲 · 全球",
      },
      contact: {
        eyebrow: "联系我们 · CONTACT",
        title: "合作、发行、版权洽谈",
        description: "如果你是艺术家、制作人或伙伴，欢迎通过邮件与我们取得联系。",
        cta: "点击复制邮箱",
        ctaCopied: "已复制",
        ctaToast: "邮箱已复制到剪贴板",
      },
      hud: {
        language: "语言",
        audioOn: "开启环境音",
        audioOff: "关闭环境音",
      },
      footer: {
        copy: "Poseidon Music · 海神音乐",
        rights: "保留所有权利",
      },
    },
  },
  en: {
    translation: {
      brand: {
        name: "Poseidon Music",
        nameEn: "海神音乐",
      },
      nav: {
        hero: "Home",
        about: "About",
        contact: "Contact",
      },
      hero: {
        eyebrow: "CHINESE MUSIC LABEL · 中文音乐厂牌",
        tagline: "Tides Rise · Music Echoes",
        taglineEn: "Tides Rise and Fall · Music Echoes Eternal",
        scroll: "Scroll",
      },
      about: {
        eyebrow: "ABOUT · 关于我们",
        title: "Moving Mandarin music outward, in tidal rhythm.",
        body1: "Poseidon Music is an independent label focused on Mandarin music releases and global partnerships. We believe in the force of the work itself—precise, edged, and enduring, like a trident of the sea.",
        body2: "From creation and production to distribution across continents, we sail beside our artists so every wave becomes an echo.",
        statReleases: "Yearly Releases",
        statReleasesValue: "36+",
        statArtists: "Signed Artists",
        statArtistsValue: "12",
        statMarkets: "Markets",
        statMarketsValue: "Asia · Global",
      },
      contact: {
        eyebrow: "CONTACT · 联系我们",
        title: "Partnerships, Releases, Licensing",
        description: "If you are an artist, producer or partner, reach out to us by email.",
        cta: "Click to copy",
        ctaCopied: "Copied",
        ctaToast: "Email copied to clipboard",
      },
      hud: {
        language: "Language",
        audioOn: "Enable ambient",
        audioOff: "Mute ambient",
      },
      footer: {
        copy: "Poseidon Music · 海神音乐",
        rights: "All rights reserved",
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "zh",
  fallbackLng: "zh",
  interpolation: { escapeValue: false },
});

// Sync html lang attribute with current language
if (typeof document !== "undefined") {
  const updateLang = (lng) => {
    document.documentElement.setAttribute("lang", lng === "zh" ? "zh-CN" : "en");
    document.documentElement.setAttribute("data-lang", lng);
  };
  updateLang(i18n.language);
  i18n.on("languageChanged", updateLang);
}

export default i18n;
